<template>
    <div class="toggle-card">
        <div class="toggle-header">
            <div class="text-block">
                <span>{{ title }}</span>
                <span :id="`${title}-tooltip`">
                    <InfoIcon class="info-icon" />
                </span>
            </div>
            <b-form-checkbox
                switch
                v-model="localValue"
                @change="$emit('input', localValue)"
                class="ml-auto"
            >
            </b-form-checkbox>
            <Tooltip
                :target="`${title}-tooltip`"
                :text="tooltip"
                placement="top"
            />
        </div>
        <transition name="fade">
            <div v-if="localValue">
                <slot class="toggle-content" />
            </div>
        </transition>
    </div>
</template>

<script>
    import { BFormCheckbox } from "bootstrap-vue";
    import Tooltip from "@/@core/layouts/layout-horizontal/components/Menu/Tooltip.vue";

    export default {
        name: "ToggleCard",
        props: {
            title: { type: String, required: true },
            value: { type: Boolean, default: false },
            tooltip: { type: String, default: "" }
        },
        components: {
            BFormCheckbox,
            Tooltip,
            InfoIcon: () => import("@core/assets/icons/info-appointment.svg")
        },
        data() {
            return {
                localValue: this.value
            };
        },
        watch: {
            value(val) {
                this.localValue = val;
            }
        }
    };
</script>

<style lang="scss">
    .toggle-card {
        border: 1px solid #d5c8ba;
        border-radius: 8px;
        padding: 1rem;
        margin-bottom: 1rem;

        .custom-switch {
            display: flex;
        }

        .custom-control-label {
            margin: 0;
            line-height: 20px;
        }

        .custom-control-input ~ .custom-control-label::before {
            background-color: #e2e2e2;
            height: 20px;
        }

        .custom-control-input:checked ~ .custom-control-label::before {
            background-color: #974900;
        }

        .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
            background-color: #e2e2e2;
            border-color: #e2e2e2;
        }
        .custom-switch .custom-control-label:after {
            top: 4px;
        }

        .text-allow {
            color: #4c4541;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            padding-right: 8px;
        }

        .info-icon {
            cursor: pointer;
            width: 16px;
            height: 16px;
            fill: #998f8a;
        }
    }
    .toggle-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .text-block {
            display: flex;
            gap: 8px;
            color: #4c4541;
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;

            svg {
                width: 12px;
                height: 12px;
                fill: #974900;
            }
        }
    }
    .toggle-content {
        margin-top: 1rem;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.2s ease;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
